module.exports = __webpack_public_path__ + "static/img/son15_active.3398612b.png";